// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#f08534","defaultTextColor":"#373737","logoTextSize":"22px"};